(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meydo-product-home-blocks"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-home-blocks]').forEach((root) => {
    const videos = root.querySelectorAll('video[data-src]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!video.src) video.src = video.dataset.src;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '500px 0px', threshold: .01 });
    videos.forEach((video) => observer.observe(video));
    const rails = {
      scenario: root.querySelector('[data-product-home-scenario-rail]'),
      mode: root.querySelector('[data-product-home-mode-rail]')
    };
    const move = (name, direction) => {
      const rail = rails[name];
      const card = rail?.querySelector('.product-home-info-card');
      if (!rail || !card) return;
      rail.scrollBy({ left: (card.getBoundingClientRect().width + 14) * direction, behavior: 'smooth' });
    };
    root.querySelectorAll('[data-product-home-prev]').forEach((button) => button.addEventListener('click', () => move(button.dataset.productHomePrev, -1)));
    root.querySelectorAll('[data-product-home-next]').forEach((button) => button.addEventListener('click', () => move(button.dataset.productHomeNext, 1)));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meydo-product-image-zoom"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.meydoProductImageZoomInitialized) return;
    window.meydoProductImageZoomInitialized = true;

    let lastTrigger = null;

    const getDialog = () => document.querySelector('[data-meydo-product-zoom]');

    const closeZoom = () => {
      const dialog = getDialog();
      if (dialog?.open) dialog.close();
    };

    const openZoom = (trigger) => {
      const dialog = getDialog();
      const zoomImage = dialog?.querySelector('[data-meydo-product-zoom-image]');
      if (!dialog || !zoomImage || !trigger.currentSrc) return;

      let zoomSource = trigger.currentSrc;
      try {
        const imageUrl = new URL(zoomSource, window.location.href);
        if (imageUrl.searchParams.has('width')) imageUrl.searchParams.set('width', '2400');
        zoomSource = imageUrl.href;
      } catch (_) {}

      lastTrigger = trigger;
      zoomImage.src = zoomSource;
      zoomImage.alt = trigger.alt || '';
      dialog.showModal();
      document.documentElement.classList.add('meydo-product-zoom-open');
      dialog.querySelector('[data-meydo-product-zoom-close]')?.focus();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-product-image-zoom-trigger]');
      if (trigger) {
        openZoom(trigger);
        return;
      }

      if (event.target.closest('[data-meydo-product-zoom-close]')) {
        closeZoom();
        return;
      }

      const dialog = getDialog();
      if (dialog?.open && event.target === dialog) closeZoom();
    });

    document.addEventListener('keydown', (event) => {
      const trigger = event.target.closest('[data-product-image-zoom-trigger]');
      if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      openZoom(trigger);
    });

    document.addEventListener('close', (event) => {
      if (!event.target.matches('[data-meydo-product-zoom]')) return;
      document.documentElement.classList.remove('meydo-product-zoom-open');
      lastTrigger?.focus();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
